import React, { FC } from 'react';
import { useNavigate } from 'react-router';
import { Button } from 'shared/ui/Button';
import queryString from 'query-string';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { AppRoutes } from 'app/config/routerConfig/types';
import { SuccessScreen } from 'shared/ui/SuccessScreen';

export const PaymentSuccessPage: FC = () => {
  const { amount } = queryString.parse(window.location.search);

  const navigate = useNavigate();
  const { t } = useAppTranslation('booking');

  const goToHomePage = (): void => {
    navigate(AppRoutes.HOME);
  };

  return (
    <div className="min-h-screen bg-backgroundColor">
      <div className="max-w-[1200px] mx-auto">
        <div className="p-[100px]">
          <SuccessScreen
            title={t('Congratulations!')}
            description={t('Box has been successfully reserved')}
            actions={
              <Button onClick={goToHomePage} size="large" containerClassName="w-full">
                {t('Home')}
              </Button>
            }
          />
        </div>
      </div>
    </div>
  );
};
